import React from 'react';
import Modal from 'react-modal';
import styled from 'styled-components';
import Privacy from './Privacy';

Modal.setAppElement('#root');

const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  background: rgba(255, 255, 255, 0.98);
`;

const Title = styled.div`
  font-weight: 800;
  color: #053969;
`;

const CloseBtn = styled.button`
  border: 1px solid rgba(0, 0, 0, 0.2);
  background: transparent;
  border-radius: 999px;
  padding: 6px 10px;
  cursor: pointer;
  font-weight: 800;

  &:hover {
    background: rgba(0, 0, 0, 0.05);
  }
`;

const Body = styled.div`
  max-height: min(70vh, 720px);
  overflow: auto;
  background: transparent;
`;

export default function PrivacyPolicyModal({ open, onClose }) {
  return (
    <Modal
      isOpen={open}
      onRequestClose={onClose}
      contentLabel="Privacy Policy"
      style={{
        overlay: {
          backgroundColor: 'rgba(0,0,0,0.55)',
          zIndex: 10000,
        },
        content: {
          maxWidth: '980px',
          width: 'calc(100% - 24px)',
          margin: 'auto',
          borderRadius: '18px',
          padding: '0',
          border: 'none',
          inset: '50% auto auto 50%',
          transform: 'translate(-50%, -50%)',
          overflow: 'hidden',
        },
      }}
    >
      <Head>
        <Title>Privacy Policy</Title>
        <CloseBtn type="button" onClick={onClose}>
          ✕
        </CloseBtn>
      </Head>

      <Body>
        <Privacy />
      </Body>
    </Modal>
  );
}
